import styled from 'styled-components'

export const StyleMonth = styled.div`
  height: 100%;
  width: 100%;
  .body {
    height: 100%;
    width: 100%;
  }
`
